<template lang="pug">
    model-form(
        ref='form'
        submit-color='success'
        submit-text='conciliar'
        title='Crear conciliaciones de cuentas'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @selected='selected'
        @submit='submit'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import AccountConciliationModel from '@/models/Accounting/AccAccountConciliation'
    import AccountConciliationFields from '@/views/Accounting/AccAccountConciliation/AccAccountConciliationFields'
    //
    export default {
        name: 'account-conciliation-create',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            formCheckboxColor() {
                return this.formCheckbox ? 'success' : 'accent'
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            fieldsProps() {
                return {
                    acc_account_trigger: this.formDataAccountTrigger,
                    acc_details_account_conciliation_checkbox_color: this.formCheckboxColor,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    fields: AccountConciliationFields(this.fieldsProps),
                    submitDisabled: ! this.formCheckbox,
                }
            },
        },
        data() {
            return {
                formCheckbox: false,
                formData: new AccountConciliationModel({
                    id: 'multi_suggest'
                }),
                formReduced: {
                    credits: [],
                    debits: [],
                },
                formSelected: [],
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * { function_description }
             */
            cleanSelected() {
                return this.formCheckbox ? this.$refs.form.getInput('details_account_conciliation').toggleAll() : null
            },

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(AccountConciliationModel, error.response.data))
            },

            /**
             * { function_description }
             */
            formDataAccountTrigger() {
                return this
                    .toWait(true)
                    .finally(this.cleanSelected)
                    .then(this.toSuggest)
                    .then(this.toWait)
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'accounting-notes-list' })
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  selected  The selected
             */
            selected(event) {
                this.formSelected = event.selected
            },

            /**
             * 
             */
            submit() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toCreate)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            success() {
                this.setSuccessSnackbar('Conciliacion de cuentas generada exitosamente.')
            },

            /**
             *
             */
            toCreate(model) {
                return model
                    .attach(this.formReduced)
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             * Returns a suggest representation of the object.
             *
             * @return     {<type>}  Suggest representation of the object.
             */
            toSuggest() {
                return this.formData.fetchMultiSuggest()
            },

            /**
             * { function_description }
             *
             * @param      {boolean}  [value=false]  The value
             * @return     {<type>}   { description_of_the_return_value }
             */
            toWait(value = false) {
                return this.$refs.form.setWait(value)
            }
        },
        watch: {

            /**
             * { function_description }
             */
            formSelected(selected) {

                //
                this.formReduced.credits = []
                this.formReduced.debits = []

                //
                let amount = 0
                let equal = true
                let last = undefined

                //
                selected.forEach(item => {

                    //
                    console.log({ item })

                    //
                    if (item.debit) this.formReduced.debits.push({
                        acc_account_id: item.acc_account_id,
                        acc_accounting_seat_id: item.id,
                    })

                    //
                    if (item.credit) this.formReduced.credits.push({
                        acc_account_id: item.acc_account_id,
                        acc_accounting_seat_id: item.id,
                    })

                    //
                    amount += (item.debit - item.credit)
                    equal = last ? item.acc_account_id === last : true
                    last = item.acc_account_id
                })

                //
                this.formCheckbox = amount === 0 && equal && last !== undefined
            },
        },
        mounted() {
            this.setTitleTopBar('Crear conciliaciones de cuentas')
        },
    }
</script>